import { Sigma, ChevronUp, ChevronDown, Trash2 } from 'lucide-react';

const eur = (v) => `${Number(v || 0).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;

const Amounts = ({ net, gross, reverseCharge, testId }) => (
  <div className="text-right text-sm leading-tight" data-testid={testId}>
    <div><span className="text-gray-500 mr-2">Netto</span><strong>{eur(net)}</strong></div>
    {!reverseCharge && <div><span className="text-gray-500 mr-2">Brutto</span><strong>{eur(gross)}</strong></div>}
  </div>
);

const MoveButtons = ({ index, count, onMove, onRemove }) => (
  <div className="flex items-center">
    <button type="button" onClick={() => onMove(index, -1)} disabled={index === 0} className="p-0.5 text-gray-500 hover:text-gray-900 disabled:opacity-30" data-testid={`subtotal-move-up-${index}`}><ChevronUp className="w-4 h-4" /></button>
    <button type="button" onClick={() => onMove(index, 1)} disabled={index === count - 1} className="p-0.5 text-gray-500 hover:text-gray-900 disabled:opacity-30" data-testid={`subtotal-move-down-${index}`}><ChevronDown className="w-4 h-4" /></button>
    <button type="button" onClick={() => onRemove(index)} className="p-1 text-red-500 hover:text-red-700" data-testid={`subtotal-remove-${index}`}><Trash2 className="w-4 h-4" /></button>
  </div>
);

export const SubtotalTableRow = ({ index, count, net, gross, reverseCharge, onMove, onRemove }) => (
  <tr className="border-b border-t-2 border-t-gray-300 bg-gray-50" data-testid={`subtotal-row-${index}`}>
    <td className="p-2"><Sigma className="w-4 h-4 text-[#9B1B30]" /></td>
    <td className="p-2 font-semibold text-sm" colSpan={3}>Zwischensumme</td>
    <td className="p-2" colSpan={2}><Amounts net={net} gross={gross} reverseCharge={reverseCharge} testId={`subtotal-amounts-${index}`} /></td>
    <td className="p-2"><MoveButtons index={index} count={count} onMove={onMove} onRemove={onRemove} /></td>
  </tr>
);

export const SubtotalCard = ({ index, count, net, gross, reverseCharge, onMove, onRemove }) => (
  <div className="border-2 border-gray-300 rounded-lg p-3 bg-gray-50 flex items-center justify-between gap-3" data-testid={`subtotal-mobile-${index}`}>
    <div>
      <span className="font-semibold text-sm flex items-center gap-1"><Sigma className="w-4 h-4 text-[#9B1B30]" /> Zwischensumme</span>
      <MoveButtons index={index} count={count} onMove={onMove} onRemove={onRemove} />
    </div>
    <Amounts net={net} gross={gross} reverseCharge={reverseCharge} testId={`subtotal-mobile-amounts-${index}`} />
  </div>
);
